/**
 * Converts number to string representation with K, M, B or T.
 * Ex: 1000 to 1M, 1500000 to 1.5M
 *
 * After decimal, rounds if necessary.
 * Ex: 1590 to 1.6K
 */
export const getKFormat = (num: number): string => {
  if (num >= 1000 && num < 1e6) {
    return +(num / 1000).toFixed(2) + "K";
  }
  if (num >= 1e6 && num < 1e9) {
    return +(num / 1e6).toFixed(2) + "M";
  }
  if (num >= 1e9 && num < 1e12) {
    return +(num / 1e9).toFixed(2) + "B";
  }
  if (num >= 1e12) {
    return +(num / 1e12).toFixed(2) + "T";
  }
  return num.toString();
};
